import r from "../managers/braze-instance.js";
import se from "./in-app-message-manager-factory.js";
export function getDeferredInAppMessage() {
  if (r.rr()) return se.ea().zr();
}
